import { DiscIcon } from '@/components/Icons';
import { useDimensions } from '@/hooks/useDimensions';
import { UserPermissionsEnum, useSessionStore } from '@/hooks/useSessionStore';
import useGeneratorStore from '@/state/generator-store';
import { cn } from '@/utils';
import React from 'react';
import TrackButton from './TrackButton';

export const MaxTracksMap = {
  [UserPermissionsEnum.Novice]: 1,
  [UserPermissionsEnum.Dabbler]: 1,
  [UserPermissionsEnum.Soloist]: 5,
  [UserPermissionsEnum.Pro]: 25,
};

const MobileTrackControl: React.FC = () => {
  const { tracksCount, setTracksCount } = useGeneratorStore();

  const { session } = useSessionStore();

  const maxTracks = MaxTracksMap[session?.user?.plan?.key as UserPermissionsEnum];

  const handleIncrement = (): void => setTracksCount((prev: number) => Math.min(maxTracks, prev + 1));
  const handleDecrement = (): void => setTracksCount((prev: number) => Math.max(1, prev - 1));

  const totalStripes = 13;
  const activeStripes = Math.floor(((tracksCount + 1) / maxTracks) * totalStripes);

  return (
    <div
      className="flex-col p-1 h-full bg-black items-start justify-center rounded-lg pointer-events-auto"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div className="flex items-center">
        <DiscIcon className="w-4 h-4" />
        <div className="flex gap-[2px] ml-1">
          {Array.from({ length: totalStripes }).map((_, index) => (
            <div key={index} className={`w-[2px] h-4 rounded-sm ${index < activeStripes ? 'bg-white' : 'bg-white/20'}`} />
          ))}
        </div>
      </div>

      <div className="flex items-center justify-center h-10 gap-1">
        <TrackButton
          size={14}
          direction="decrease"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            handleDecrement();
          }}
        />
        <span className="text-[1.25rem] w-[24px] font-medium text-center text-white">{tracksCount}</span>
        <TrackButton
          size={14}
          direction="increase"
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            handleIncrement();
          }}
        />
      </div>

      <div className="flex items-center justify-center mt-[-6px] ml-1">
        <span className="text-[#e0e4e4] text-[12px] font-bold font-pressura-mono uppercase">
          TRACK<span className={cn({ 'opacity-30': tracksCount <= 1 })}>S</span>
        </span>
      </div>
    </div>
  );
};

export default MobileTrackControl;
